/** Form action mode for create/edit/duplicate/view dialogs. */
export enum FormAction {
  Create = "create",
  Edit = "edit",
  Duplicate = "duplicate",
  /** Read-only rendering of an existing record — every input disabled, no save. */
  View = "view",
}

/** Adapter type from the API's type field. */
export enum AdapterType {
  Rest = "REST",
  Soap = "SOAP",
  Websocket = "WEBSOCKET",
}

/** Protocol type from the API's protocol_type field. */
export enum ProtocolType {
  Mce = "MCE",
  Modbus = "MODBUS",
  Beagle = "BEAGLE",
  Ln1 = "LN1",
  Diligent = "DILIGENT",
  Bacnet = "BACNET",
  Rvu = "RVU",
  Opc = "OPC",
  OpcUa = "OPCUA",
  NumatoGpio = "NUMATOGPIO",
  NumatoRelay = "NUMATORELAY",
  Sequent = "SEQUENT",
  Stm32 = "STM32",
  Ln2 = "LN2",
}

/** Channel type from the API's type field on channels. */
export enum ChannelType {
  Serial = "SERIAL",
  Tcp = "TCP",
  TcpBot = "TCP_BOT",
  Adapter = "ADAPTER",
}

/** Channel connection type from the API's connection_type field. */
/**
 * The channel transports the wizard offers. Each value is the name of the
 * generated `ChannelType` member it saves as (see CHANNEL_CONNECTION_TYPE_TO_FBS
 * in pages/setupWizard/utils/channelAddress.ts, which is exhaustive over this
 * enum, so a transport added here without a FlatBuffer value fails to compile).
 *
 * ADAPTER is the socketless connection type: LiftCloud lets it carry only
 * adapters that are not addressed by host:port — OPC UA (reached through the
 * channel's opc_ua_endpoint_url) and a Numato relay controller board.
 */
export enum ChannelConnectionType {
  Tcp = "TCP",
  Serial = "SERIAL",
  Udp = "UDP",
  Adapter = "ADAPTER",
}

/** Authentication type for adapters. */
export enum AuthType {
  None = "NONE",
  Password = "PASSWORD",
  ApiKey = "APIKEY",
  Jwt = "JWT",
  Oauth = "OAUTH",
}

/** Date grouping period for reports. */
export enum DatePeriod {
  Today = "TODAY",
  Week = "WEEK",
  Month = "MONTH",
  Quarter = "QUARTER",
  Year = "YEAR",
}

/**
 * RVU heartbeat mode from the adapter CDO's `heartbeat_kind` field.
 * RVU-specific — selects whether the adapter sends a mapped on/off
 * status-bit toggle, a wire-level RvuHeartBeat keepalive, or both.
 */
export enum HeartbeatKind {
  Mapped = "mapped",
  Rvu = "rvu",
  Both = "both",
}
